import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import './Header.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faFacebookSquare, faGithubSquare, faGoogle, faLinkedin, faWhatsappSquare } from "@fortawesome/fontawesome-free-brands";
import { faArrowTrendDown} from "@fortawesome/free-solid-svg-icons";

function Header() {
    const container = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
          container: container.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: require("../../../animation/landing.json.json")
        });
    
        return () => {
          lottie.destroy();
        };
      }, []);

      
  return (
    <>
    
        <div className="header" id="header">
            <div className="container">
                <div className="info" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                    <h1>Hello,</h1>
                    <p>I'm Eslam <span>Elhadi</span>dy,</p>
                    <h4>Front-End Developer</h4>
                    <q>Passionate about coding and Designing...</q>
                    <div className="more">
                        <h6>Read More <a href="#about"><FontAwesomeIcon icon={faArrowTrendDown} /></a></h6>
                    </div>
                </div>
                <div className="img" ref={container} data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1500">
                    
                </div>
                <div className="blur"></div>
            </div>
                <div className="social" >
                    <ul>
                        <a href="https://www.facebook.com/El7aDiiDy" target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faFacebookSquare}/></a>
                        <a href="https://github.com/IslamElhadidy" target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faGithubSquare}/></a>
                        <a href="https://www.linkedin.com/in/eslamelhadidy/" target='_blank'  rel="noreferrer"><FontAwesomeIcon icon={faLinkedin}/></a>
                        <a href="https://api.whatsapp.com/send?phone=201060088542" target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faWhatsappSquare}/></a>
                        <a href='mailto:elhadidii624@gmail.com' target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faGoogle}/></a>
                    </ul>
                </div>
        </div>
    </>
  )
}

export default Header